import {
  Component,
  EventEmitter,
  input,
  Input,
  model,
  OnInit,
  output,
  Output,
} from '@angular/core';
import { Types } from 'shared-lib';
import {
  EComponentSize,
  EIcon,
  ELabelType,
  ICircularProgressType,
  ISidebarUser,
} from '../../types';
import { CircularProgressComponent } from '../circular-progress/circular-progress.component';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../label/label.component';
import { PhotoComponent } from '../photo/photo.component';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { FileService } from '../../service/files.service';

@Component({
  selector: 'ui-sidebar',
  standalone: true,
  imports: [CommonModule, CircularProgressComponent, LabelComponent, PhotoComponent],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  type = model<Types.EAlert>(Types.EAlert.DARK);
  userProgress = input<ICircularProgressType[]>();

  action = output<string>();

  user: ISidebarUser = {
    photoUrl: '',
    name: ''
  };
  isCollapsed: boolean = true;
  EAlert = Types.EAlert;
  ELabelType = ELabelType;
  EComponentSize = EComponentSize;
  textType = this.EAlert.DARK;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private fileService: FileService
  ) { }

  async ngOnInit() {
    await this.userData();
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  onProgressClick(progressName: string, clickable: boolean) {
    if (clickable) {
      this.action.emit(progressName);
    }
  }

  sidebarClasses() {
    return {
      'left-0': !this.isCollapsed,
      '-left-64': this.isCollapsed,
      'w-64': !this.isCollapsed,
      ...this.getSidebarClassByType(),
      ...this.getTextColorByType(this.type()),
    };
  }

  buttonClasses() {
    return {
      '-left-[15px]': this.isCollapsed,
      'left-60': !this.isCollapsed,
      'bg-gray-800': !this.isCollapsed,
      'bg-transparent': this.isCollapsed,
    };
  }

  getSidebarClassByType() {
    switch (this.type()) {
      case this.EAlert.DANGER:
        return { 'bg-red-600': true, 'text-white': true };
      case this.EAlert.SUCCESS:
        return { 'bg-green-600': true, 'text-white': true };
      case this.EAlert.WARNING:
        return { 'bg-yellow-600': true, 'text-black': true };
      case this.EAlert.DARK:
        return { 'bg-gray-800': true, 'text-white': true };
      case this.EAlert.LIGHT:
        return { 'bg-white-800': true, 'text-black': true };
      case this.EAlert.INFO:
      default:
        return { 'bg-blue-600': true, 'text-white': true };
    }
  }

  getTextColorByType(color: Types.EAlert) {
    switch (color) {
      case this.EAlert.DANGER:
      case this.EAlert.WARNING:
      case this.EAlert.LIGHT:
        this.textType = this.EAlert.DARK;
        return { 'text-black': true };
      default:
        this.textType = this.EAlert.INFO;
        return { 'text-white': true };
    }
  }

  async loadFile(id: number, name: string) {
    let fileResponse = await this.fileService.getFileById(id);

    if (fileResponse) {
      this.user.photoUrl = fileResponse.base64;
    }

    this.user.name = name;
  }

  async userData() {
    let userResponse = await this.authService.getUserInfo();

    if (userResponse) {
      this.loadFile(Number(userResponse.avatar?.id), userResponse.name)
    }
  }

}
